import { render, staticRenderFns } from "./newsIndex.vue?vue&type=template&id=da09e402&scoped=true&"
import script from "./newsIndex.vue?vue&type=script&lang=js&"
export * from "./newsIndex.vue?vue&type=script&lang=js&"
import style0 from "./newsIndex.vue?vue&type=style&index=0&id=da09e402&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da09e402",
  null
  
)

export default component.exports